var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:`text-xs-center mt-4 pt-4 mb-${_vm.bottomMargin} pb-${_vm.bottomMargin}`},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }